import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import PhoneIcon from '../../../globals/images/icon-phone.svg'
import EmailIcon from '../../../globals/images/icon-blue-email.svg'
import { MFA } from '../MFASteps'
import { trackEventMessage } from '../../../TelemetryService'
import { EventModel } from '../../../models/EventModel'
import { MFA_SETUP_VERIFICATION } from '../../../constants'
import Container from '../../shared/container/Container'
import FactorOption from '../../shared/factorOption/FactorOption'
import { LoadingButton as Button } from '../LoadingButton/LoadingButton' 

export default function ChooseFactor( { onClose, onHandleClick , webId } ) {

    const headerReference = useRef( null )

    const onHandleClose = ( ) => {
        trackEventMessage( new EventModel( MFA_SETUP_VERIFICATION.CLOSE, webId ) )
        onClose()
    }
    
    const onClick = ( factor ) => {
        const aiMessage = factor == MFA.FACTORS.EMAIL ? MFA_SETUP_VERIFICATION.EMAIL_SETUP : MFA_SETUP_VERIFICATION.SMS_SETUP
        trackEventMessage( new EventModel( aiMessage, webId ) )
        onHandleClick( factor )
    }
    
    useEffect( () => {
        headerReference?.current?.focus() 
    }, [] 
    )
    
  return ( <Container onClose={ onHandleClose } onCloseButtonId='dt-mfa-setupverification-close'>  
      <div className='mb-6'>              
          <header ref={ headerReference } className='mb-7 c-mfa-label--title' aria-label={ MFA.ChooseFactor.title } tabIndex='0'>{ MFA.ChooseFactor.title }</header>                
          <FactorOption img={ PhoneIcon } title= { MFA.ChooseFactor.smsTextTitle } description= { MFA.ChooseFactor.smsText } bold  />
          <div>
              <Button id='dt-mfa-setupverification-sms-setup' className={ 'c-btn c-btn--tertiary mb-6' } onClick={ () => onClick( MFA.FACTORS.SMS ) } aria-label={ MFA.ChooseFactor.buttonText + ' Enabled' } name="setupButton" type='button' data-testid="btn-textSetup">{ MFA.ChooseFactor.buttonText }</Button>
          </div>
      </div>
      <div className='hr-line mb-6'></div>
      <div>
          <FactorOption img={ EmailIcon } title= { MFA.ChooseFactor.emailTextTitle } description= { MFA.ChooseFactor.emailText } bold  />
          <div>
              <Button id='dt-mfa-setupverification-email-setup' className={ 'c-btn c-btn--tertiary mb-3' } onClick={ () => onClick( MFA.FACTORS.EMAIL ) } aria-label={ MFA.ChooseFactor.buttonEmailText + ' Enabled' } name="setupButton" type='button' data-testid="btn-emailSetup">{ MFA.ChooseFactor.buttonEmailText }</Button>
          </div>
      </div> 
  </Container>
  )
}

ChooseFactor.propTypes = {
    onClose: PropTypes.func,
    onHandleClick: PropTypes.func,
    webId: PropTypes.string
}